import type { DataTableHeader } from '@/types/vuetify';

export function createBookBalanceTableHeaders(): DataTableHeader[] {
    const { t } = useI18n();

    return [
        {
            title: t('bookBalance.bookmaker'),
            value: 'bookmaker',
            key: 'bookmaker',
            align: 'start',
            sortable: false,
            nowrap: true,
        },
        {
            title: '',
            value: 'currency',
            key: 'currency',
            align: 'center',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.betCount'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.staked'),
            value: 'staked',
            key: 'staked',
            align: 'end',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('bookBalance.turnover'),
            value: 'turnover',
            key: 'turnover',
            align: 'end',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('bookBalance.agTurnover'),
            value: 'agTurnover',
            key: 'agTurnover',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookStaked'),
            value: 'bookStaked',
            key: 'bookStaked',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookTurnover'),
            value: 'bookTurnover',
            key: 'bookTurnover',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookComm'),
            value: 'bookComm',
            key: 'bookComm',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookFees'),
            value: 'bookFees',
            key: 'bookFees',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.feesRebate'),
            value: 'feesRebate',
            key: 'feesRebate',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.position'),
            value: 'position',
            key: 'position',
            align: 'end',
            sortable: false,
            nowrap: true,
            minWidth: 80,
        },
        {
            title: t('bookBalance.coPositionBalance'),
            value: 'coPositionBalance',
            key: 'coPositionBalance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookBalance'),
            value: 'bookBalance',
            key: 'bookBalance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.agBalance'),
            value: 'agBalance',
            key: 'agBalance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.playerBalance'),
            value: 'playerBalance',
            key: 'playerBalance',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.playerYield'),
            value: 'playerYield',
            key: 'playerYield',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.payComms'),
            value: 'payComms',
            key: 'payComms',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.bookTotal'),
            value: 'bookTotal',
            key: 'bookTotal',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
        {
            title: t('bookBalance.companyPL'),
            value: 'companyPL',
            key: 'companyPL',
            align: 'end',
            sortable: false,
            nowrap: true,
        },
    ];
}
